import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';

/**
 * Progress table cell (design handoff, "Data table pattern"): an 80x6px
 * track (`--sm-mist`) with a fill and an "n/m" label. Fill colour: complete
 * (done === total, total > 0) -> success, none (done === 0) -> warning,
 * otherwise -> amber. Standalone, no styles of its own -- see
 * `.cell-progress*` in `@seahorse/theme`'s `_table.scss`.
 */
@Component({
  selector: 'sh-cell-progress',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
  template: `
    <div class="cell-progress">
      <span class="cell-progress-track">
        <span
          class="cell-progress-fill"
          [class]="fillClass()"
          [style.width.%]="percentage()"
        ></span>
      </span>
      <span class="cell-progress-label">{{ done() }}/{{ total() }}</span>
    </div>
  `,
})
export class CellProgressComponent {
  done = input.required<number>();
  total = input.required<number>();

  protected readonly percentage = computed(() => {
    const total = this.total();
    if (!total) return 0;
    return Math.max(0, Math.min(100, (this.done() / total) * 100));
  });

  protected readonly fillClass = computed(() => {
    const done = this.done();
    const total = this.total();
    if (total > 0 && done === total) return 'cell-progress-fill-success';
    if (done === 0) return 'cell-progress-fill-warn';
    return 'cell-progress-fill-amber';
  });
}
